import React from "react";
import PracticsQuestionTopics from "../../topics/PracticsQuestionTopics";


function PracticeQuestionsBioTopics() {
  return (
    <>

      <PracticsQuestionTopics subject="biology" type="dpp" />

    </>
  );
}

export default PracticeQuestionsBioTopics;